<script setup>

</script>

<template>
  <div>
    <!-- head -->
    <div class="section section--head">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12">
            <div class="section__title">
              <h1>Token Centure</h1>
              <p>More features with own Centure token.</p>
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- token -->
    <div class="section section--pb">
      <div class="container">
        <div class="row row--relative">
          <div class="col-12">
            <!-- invest -->
            <div class="invest invest--big">
              <h2 class="invest__title">Centure Token</h2>

              <div class="row">
                <div class="col-12 col-lg-5">
                  <div class="invest__rate-wrap">
                    <div class="invest__rate">
                      <span>Current course</span>
                      <p>1 Ctr = $0.791</p>
                    </div>

                    <div class="invest__graph">
                      <img src="img/graph/graph2.svg" alt="">
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-5 offset-lg-1">
                  <div class="invest__rate-wrap">
                    <div class="invest__rate">
                      <span>Week</span>
                      <!-- or .red -->
                      <p class="green">+0.19% <small>[0.84]</small></p>
                    </div>

                    <div class="invest__graph">
                      <img src="img/graph/graph1.svg" alt="">
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-5">
                  <div class="invest__rate-wrap">
                    <div class="invest__rate">
                      <span>Month</span>
                      <p class="red">-2.84% <small>[0.02]</small></p>
                    </div>

                    <div class="invest__graph">
                      <img src="img/graph/graph3.svg" alt="">
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-5 offset-lg-1">
                  <div class="invest__rate-wrap">
                    <div class="invest__rate">
                      <span>All the time</span>
                      <p class="green">+65.10% <small>[49.68]</small></p>
                    </div>

                    <div class="invest__graph">
                      <img src="img/graph/graph4.svg" alt="">
                    </div>
                  </div>
                </div>
              </div>

              <p class="invest__info">Centure is a proprietary token of the Centure TRADE project. It is a full-fledged trading unit. Centure was developed as a universal means of payment, allowing people to profit at the actual rate of their currency in the arbitrage pool. Centure token does not depend on the cryptocurrency market and is completely in its own ecosystem.</p>

              <!-- design elements -->
              <span class="block-icon block-icon--purple">
							<i class="ti ti-brand-coinbase"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
            <!-- end invest -->
          </div>

          <!-- animation background -->
          <div class="section__canvas section__canvas--page section__canvas--first" id="canvas"></div>
        </div>
      </div>
    </div>
    <!-- end token -->

    <!-- features -->
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-4">
            <!-- feature -->
            <div class="feature">
              <h3 class="feature__title">Daily profit</h3>
              <p class="feature__text">All profit accruals are made daily in Centure tokens</p>

              <!-- design elements -->
              <span class="block-icon block-icon--green">
							<i class="ti ti-currency-dollar"></i>
						</span>
              <span class="screw screw--bl"></span>
              <span class="screw screw--tr"></span>
              <span class="screw screw--big-br"></span>
            </div>
            <!-- end feature -->
          </div>

          <div class="col-12 col-md-6 col-lg-4">
            <!-- feature -->
            <div class="feature">
              <h3 class="feature__title">Bonuses</h3>
              <p class="feature__text">Profit daily from the growth of your arbitrage pool volume</p>

              <!-- design elements -->
              <span class="block-icon block-icon--blue">
							<i class="ti ti-gift"></i>
						</span>
              <span class="screw screw--bl"></span>
              <span class="screw screw--tr"></span>
              <span class="screw screw--big-br"></span>
            </div>
            <!-- end feature -->
          </div>

          <div class="col-12 col-md-6 col-lg-4">
            <!-- feature -->
            <div class="feature">
              <h3 class="feature__title">Rewards</h3>
              <p class="feature__text">Distribution of tokens as a reward for the growth of arbitrage pool turnover</p>

              <!-- design elements -->
              <span class="block-icon block-icon--yellow">
							<i class="ti ti-trophy"></i>
						</span>
              <span class="screw screw--bl"></span>
              <span class="screw screw--tr"></span>
              <span class="screw screw--big-br"></span>
            </div>
            <!-- end feature -->
          </div>
        </div>
      </div>
    </div>
    <!-- end features -->

    <!-- nodes -->
    <section class="section">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div class="section__title">
              <h2>Arbitrage Nodes</h2>
              <p>Secure a unique opportunity to engage in cryptocurrency arbitrage by acquiring arbitrage nodes on our platform.</p>
            </div>
          </div>
          <!-- end title -->
        </div>

        <div class="row">
          <div class="col-12 col-md-6 col-lg-4">
            <!-- node -->
            <div class="node">
              <h3 class="node__title node__title--orange"><b>100</b> Centure</h3>
              <span class="node__date">30 days</span>
              <span class="node__price">Partner course: <b>$59.64</b></span>
              <span class="node__line"><img src="img/dodgers/dots--line-orange.svg" alt=""></span>

              <ul class="node__list">
                <li><i class="ti ti-circle-check"></i><b>3%</b> of the deposit amount</li>
                <li><i class="ti ti-circle-check"></i><b>$100</b> to the principal balance</li>
                <li><i class="ti ti-circle-check"></i><b>$200</b> bonus balance</li>
                <li><i class="ti ti-circle-check"></i><b>+ 0.5%</b> daily profit</li>
              </ul>

              <button class="node__btn" data-bs-target="#modal-node" type="button" data-bs-toggle="modal">Buy Nodes</button>

              <!-- design elements -->
              <span class="stats__dodger stats__dodger--left stats__dodger--orange"></span>
              <span class="stats__dodger stats__dodger--right stats__dodger--orange"></span>
            </div>
            <!-- end node -->
          </div>

          <div class="col-12 col-md-6 col-lg-4">
            <!-- node -->
            <div class="node">
              <h3 class="node__title node__title--green"><b>200</b> Centure</h3>
              <span class="node__date">45 days</span>
              <span class="node__price">Partner course: <b>$119.28</b></span>
              <span class="node__line"><img src="img/dodgers/dots--line-green.svg" alt=""></span>

              <ul class="node__list">
                <li><i class="ti ti-circle-check"></i><b>5%</b> of the deposit amount</li>
                <li><i class="ti ti-circle-check"></i><b>$200</b> to the principal balance</li>
                <li><i class="ti ti-circle-check"></i><b>$300</b> bonus balance</li>
                <li><i class="ti ti-circle-check"></i><b>+ 0.9%</b> daily profit</li>
              </ul>

              <button class="node__btn" data-bs-target="#modal-node" type="button" data-bs-toggle="modal">Buy Nodes</button>

              <!-- design elements -->
              <span class="stats__dodger stats__dodger--left stats__dodger--green"></span>
              <span class="stats__dodger stats__dodger--right stats__dodger--green"></span>
            </div>
            <!-- end node -->
          </div>

          <div class="col-12 col-lg-4">
            <!-- node -->
            <div class="node">
              <h3 class="node__title node__title--blue"><b>500</b> Centure</h3>
              <span class="node__date">60 days</span>
              <span class="node__price">Partner course: <b>$298.20</b></span>
              <span class="node__line"><img src="img/dodgers/dots--line-blue.svg" alt=""></span>

              <ul class="node__list">
                <li><i class="ti ti-circle-check"></i><b>7%</b> of the deposit amount</li>
                <li><i class="ti ti-circle-check"></i><b>$400</b> to the principal balance</li>
                <li><i class="ti ti-circle-check"></i><b>$600</b> bonus balance</li>
                <li><i class="ti ti-circle-check"></i><b>+ 1.8%</b> daily profit</li>
              </ul>

              <button class="node__btn" data-bs-target="#modal-node" type="button" data-bs-toggle="modal">Buy Nodes</button>

              <!-- design elements -->
              <span class="stats__dodger stats__dodger--left stats__dodger--blue"></span>
              <span class="stats__dodger stats__dodger--right stats__dodger--blue"></span>
            </div>
            <!-- end node -->
          </div>
        </div>
      </div>
    </section>
    <!-- end nodes -->
  </div>
</template>

<style scoped>

</style>
